// extracted by mini-css-extract-plugin
export default {"title":"DocumentColumns_title__q8l4Y","impacts-container":"DocumentColumns_impacts-container__ADpQG"};